export * from './icons';

export type { TSVGIcon, IIconProps } from './interface';
